import { RouteConfig } from 'vue-router';

import Login from '@/entries/user/pages/login/Login.vue';
import PasswordReset from '@/entries/user/pages/password/reset/PasswordReset.vue';
import Exception from '@/entries/user/pages/exception/Exception.vue';
import Unauthorized from '@/entries/user/pages/unauthorized/Unauthorized.vue';

import Authorized from '@/entries/user/pages/authorized/Authorized.vue';
import ライセンス from '@/entries/user/pages/authorized/ライセンス/ライセンス.vue';
import 事業所List from '@/entries/user/pages/authorized/事業所/list/事業所List.vue';
import 事業所Edit from '@/entries/user/pages/authorized/事業所/edit/事業所Edit.vue';
import 勘定科目 from '@/entries/user/pages/authorized/事業所/勘定科目/勘定科目.vue';
import 部門 from '@/entries/user/pages/authorized/事業所/部門/部門.vue';
import 計画書 from '@/entries/user/pages/authorized/事業所/計画書/計画書.vue';
import 取込 from '@/entries/user/pages/authorized/事業所/計画書/取込/取込.vue';
import 分析 from '@/entries/user/pages/authorized/事業所/計画書/分析/分析.vue';
import 三表実績 from '@/entries/user/pages/authorized/事業所/計画書/分析/三表実績/三表実績.vue';
import 現状変動損益 from '@/entries/user/pages/authorized/事業所/計画書/分析/現状変動損益/現状変動損益.vue';
import 借入登録 from '@/entries/user/pages/authorized/事業所/計画書/分析/借入登録/借入登録.vue';
import 保有不動産 from '@/entries/user/pages/authorized/事業所/計画書/分析/保有不動産/保有不動産.vue';
import 償却不足額 from '@/entries/user/pages/authorized/事業所/計画書/分析/償却不足額/償却不足額.vue';
import 実態BS from '@/entries/user/pages/authorized/事業所/計画書/分析/実態BS/実態BS.vue';
import 計画 from '@/entries/user/pages/authorized/事業所/計画書/計画/計画.vue';
import 三表 from '@/entries/user/pages/authorized/事業所/計画書/計画/三表/三表.vue';
import 設備投資 from '@/entries/user/pages/authorized/事業所/計画書/計画/設備投資/設備投資.vue';
import 償却予測額 from '@/entries/user/pages/authorized/事業所/計画書/計画/償却予測額/償却予測額.vue';
import 借入返済 from '@/entries/user/pages/authorized/事業所/計画書/計画/借入返済/借入返済.vue';
import 納税予測 from '@/entries/user/pages/authorized/事業所/計画書/計画/納税予測/納税予測.vue';
import 資金繰り予定 from '@/entries/user/pages/authorized/事業所/計画書/計画/資金繰り予定/資金繰り予定.vue';
import 計画変動損益 from '@/entries/user/pages/authorized/事業所/計画書/計画/計画変動損益/計画変動損益.vue';
import 実態純資産 from '@/entries/user/pages/authorized/事業所/計画書/計画/実態純資産/実態純資産.vue';
import モニタリング from '@/entries/user/pages/authorized/事業所/計画書/モニタリング/モニタリング.vue';
import 差異分析 from '@/entries/user/pages/authorized/事業所/計画書/モニタリング/差異分析/差異分析.vue';
import 業績予測 from '@/entries/user/pages/authorized/事業所/計画書/モニタリング/業績予測/業績予測.vue';

/** 公開ルート型定義 */
type PublicRoutes = {
  Login: RouteConfig;
  PasswordReset: RouteConfig;
  Unauthorized: RouteConfig;
  Exception: RouteConfig;
  NotFound: RouteConfig;
};

/** 認証済ルート型定義 */
type AuthorizedRoutes = {
  事業所List: RouteConfig;
  ライセンス: RouteConfig;
  事業所Create: RouteConfig;
  事業所Edit: RouteConfig;
  勘定科目: RouteConfig;
  部門: RouteConfig;
  計画書: RouteConfig;
  取込: RouteConfig;
  分析: RouteConfig;
  計画: RouteConfig;
  モニタリング: RouteConfig;
  三表実績: RouteConfig;
  現状変動損益: RouteConfig;
  借入登録: RouteConfig;
  保有不動産: RouteConfig;
  償却不足額: RouteConfig;
  実態BS: RouteConfig;
  三表: RouteConfig;
  設備投資: RouteConfig;
  償却予測額: RouteConfig;
  借入返済: RouteConfig;
  納税予測: RouteConfig;
  資金繰り予定: RouteConfig;
  計画変動損益: RouteConfig;
  実態純資産: RouteConfig;
  差異分析: RouteConfig;
  業績予測: RouteConfig;
};

/** ルート型定義 */
export type RoutesType = PublicRoutes & AuthorizedRoutes;

/** 公開ルート定義 */
export const PublicRoutes: PublicRoutes = {
  Login: {
    path: '/user',
    name: 'Login',
    component: Login,
  },
  PasswordReset: {
    path: '/user/password/:jwt',
    name: 'PasswordReset',
    component: PasswordReset,
  },
  Unauthorized: {
    path: '/user/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized,
  },
  Exception: {
    path: '/user/exception',
    name: 'Exception',
    component: Exception,
  },
  NotFound: {
    path: '*',
    name: 'NotFound',
    component: Exception,
  },
};

/** 認証済ルート定義 */
export const AuthorizedRoutes: AuthorizedRoutes = {
  事業所List: {
    // /user/事業所
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80',
    name: '事業所List',
    component: 事業所List,
  },
  ライセンス: {
    // /user/ライセンス
    path: '/user/%E3%83%A9%E3%82%A4%E3%82%BB%E3%83%B3%E3%82%B9',
    name: 'ライセンス',
    component: ライセンス,
  },
  事業所Create: {
    // /user/事業所/new
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/new',
    name: '事業所Create',
    component: 事業所Edit,
  },
  事業所Edit: {
    // /user/事業所/edit/:事業所pk
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/edit/:pk',
    name: '事業所Edit',
    component: 事業所Edit,
  },
  勘定科目: {
    // /user/事業所/勘定科目
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E5%8B%98%E5%AE%9A%E7%A7%91%E7%9B%AE',
    name: '勘定科目',
    component: 勘定科目,
  },
  部門: {
    // /user/事業所/部門
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E9%83%A8%E9%96%80',
    name: '部門',
    component: 部門,
  },
  計画書: {
    // /user/事業所/計画書
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8',
    name: '計画書',
    component: 計画書,
  },
  取込: {
    // /user/事業所/計画書/取込
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E5%8F%96%E8%BE%BC',
    name: '取込',
    component: 取込,
  },
  分析: {
    // /user/事業所/計画書/分析
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E5%88%86%E6%9E%90',
    name: '分析',
    component: 分析,
  },
  計画: {
    // /user/事業所/計画書/計画
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E8%A8%88%E7%94%BB',
    name: '計画',
    component: 計画,
  },
  モニタリング: {
    // /user/事業所/計画書/モニタリング
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E3%83%A2%E3%83%8B%E3%82%BF%E3%83%AA%E3%83%B3%E3%82%B0',
    name: 'モニタリング',
    component: モニタリング,
  },

  // 以降、別タブ、ヘッダー、サイドメニューなし
  三表実績: {
    // /user/事業所/計画書/分析/三表実績
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E5%88%86%E6%9E%90/%E4%B8%89%E8%A1%A8%E5%AE%9F%E7%B8%BE',
    name: '三表実績',
    component: 三表実績,
    meta: {
      mainNavigation: false,
    },
  },
  現状変動損益: {
    // /user/事業所/計画書/分析/現状変動損益
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E5%88%86%E6%9E%90/%E7%8F%BE%E7%8A%B6%E5%A4%89%E5%8B%95%E6%90%8D%E7%9B%8A',
    name: '現状変動損益',
    component: 現状変動損益,
    meta: {
      mainNavigation: false,
    },
  },
  借入登録: {
    // /user/事業所/計画書/分析/借入登録
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E5%88%86%E6%9E%90/%E5%80%9F%E5%85%A5%E7%99%BB%E9%8C%B2',
    name: '借入登録',
    component: 借入登録,
    meta: {
      mainNavigation: false,
    },
  },
  保有不動産: {
    // /user/事業所/計画書/分析/保有不動産
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E5%88%86%E6%9E%90/%E4%BF%9D%E6%9C%89%E4%B8%8D%E5%8B%95%E7%94%A3',
    name: '保有不動産',
    component: 保有不動産,
    meta: {
      mainNavigation: false,
    },
  },
  償却不足額: {
    // /user/事業所/計画書/分析/償却不足額
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E5%88%86%E6%9E%90/%E5%84%9F%E5%8D%B4%E4%B8%8D%E8%B6%B3%E9%A1%8D',
    name: '償却不足額',
    component: 償却不足額,
    meta: {
      mainNavigation: false,
    },
  },
  実態BS: {
    // /user/事業所/計画書/分析/実態BS
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E5%88%86%E6%9E%90/%E5%AE%9F%E6%85%8BBS',
    name: '実態BS',
    component: 実態BS,
    meta: {
      mainNavigation: false,
    },
  },
  三表: {
    // /user/事業所/計画書/計画/三表
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E8%A8%88%E7%94%BB/%E4%B8%89%E8%A1%A8',
    name: '三表',
    component: 三表,
    meta: {
      mainNavigation: false,
    },
  },
  設備投資: {
    // /user/事業所/計画書/計画/設備投資
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E8%A8%88%E7%94%BB/%E8%A8%AD%E5%82%99%E6%8A%95%E8%B3%87',
    name: '設備投資',
    component: 設備投資,
    meta: {
      mainNavigation: false,
    },
  },
  償却予測額: {
    // /user/事業所/計画書/計画/償却予測額
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E8%A8%88%E7%94%BB/%E5%84%9F%E5%8D%B4%E4%BA%88%E6%B8%AC%E9%A1%8D',
    name: '償却予測額',
    component: 償却予測額,
    meta: {
      mainNavigation: false,
    },
  },
  借入返済: {
    // /user/事業所/計画書/計画/借入返済
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E8%A8%88%E7%94%BB/%E5%80%9F%E5%85%A5%E8%BF%94%E6%B8%88',
    name: '借入返済',
    component: 借入返済,
    meta: {
      mainNavigation: false,
    },
  },
  納税予測: {
    // /user/事業所/計画書/計画/納税予測
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E8%A8%88%E7%94%BB/%E7%B4%8D%E7%A8%8E%E4%BA%88%E6%B8%AC',
    name: '納税予測',
    component: 納税予測,
    meta: {
      mainNavigation: false,
    },
  },
  資金繰り予定: {
    // /user/事業所/計画書/計画/資金繰り予定
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E8%A8%88%E7%94%BB/%E8%B3%87%E9%87%91%E7%B9%B0%E3%82%8A%E4%BA%88%E5%AE%9A',
    name: '資金繰り予定',
    component: 資金繰り予定,
    meta: {
      mainNavigation: false,
    },
  },
  計画変動損益: {
    // /user/事業所/計画書/計画/計画変動損益
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E8%A8%88%E7%94%BB/%E8%A8%88%E7%94%BB%E5%A4%89%E5%8B%95%E6%90%8D%E7%9B%8A',
    name: '計画変動損益',
    component: 計画変動損益,
    meta: {
      mainNavigation: false,
    },
  },
  実態純資産: {
    // /user/事業所/計画書/計画/実態純資産
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E8%A8%88%E7%94%BB/%E5%AE%9F%E6%85%8B%E7%B4%94%E8%B3%87%E7%94%A3',
    name: '実態純資産',
    component: 実態純資産,
    meta: {
      mainNavigation: false,
    },
  },
  差異分析: {
    // /user/事業所/計画書/モニタリング/差異分析
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E3%83%A2%E3%83%8B%E3%82%BF%E3%83%AA%E3%83%B3%E3%82%B0/%E5%B7%AE%E7%95%B0%E5%88%86%E6%9E%90',
    name: '差異分析',
    component: 差異分析,
    meta: {
      mainNavigation: false,
    },
  },
  業績予測: {
    // /user/事業所/計画書/モニタリング/業績予測
    path: '/user/%E4%BA%8B%E6%A5%AD%E6%89%80/%E8%A8%88%E7%94%BB%E6%9B%B8/%E3%83%A2%E3%83%8B%E3%82%BF%E3%83%AA%E3%83%B3%E3%82%B0/%E6%A5%AD%E7%B8%BE%E4%BA%88%E6%B8%AC',
    name: '業績予測',
    component: 業績予測,
    meta: {
      mainNavigation: false,
    },
  },
};

export default class AppRouteConfig {
  /**
   * vue-routerの設定用配列を取得します。
   *
   * @returns vue-routerの設定用配列
   */
  public static getVueRouterConfig(): RouteConfig[] {
    const configs = Object.values(PublicRoutes);
    configs.push({
      path: '/user/authorized',
      component: Authorized,
      children: Object.values(AuthorizedRoutes),
    });
    return configs;
  }
}
